import { useEditHomeTabMutate } from '../../../../hooks/queries/home/useEditHomeTabMutate';
import { useState } from 'react';
import { HomeTabEditErrorCode, HomeTabEditRequest } from '../../../../types/home/tab';
import { CustomAxiosError } from '../../../../types/common/http';
import { HomeTabsCreateResponseBodyDto } from '../../../../types/api/home-tabs';

type UseCreateHomeTabReturnType = {
  targetTabId: number | null;
  changeTargetTabId: (id: number | null) => void;
  editHomeTab: (tab: HomeTabEditRequest) => void;
  isEditHomeTabLoading: boolean;
};

interface UseEditHomeTabProps {
  onSuccess?: (res: HomeTabsCreateResponseBodyDto) => void;
  onError?: (err: CustomAxiosError<HomeTabEditErrorCode>) => void;
}

export const useEditHomeTab = (props?: UseEditHomeTabProps): UseCreateHomeTabReturnType => {
  const [targetTabId, setTargetTabId] = useState<number | null>(null);

  const { mutate, isLoading } = useEditHomeTabMutate({
    onSuccess: (res) => {
      if (props?.onSuccess) props?.onSuccess(res);
    },
    onError: props?.onError,
    onSettled: () => setTargetTabId(null),
  });

  return {
    targetTabId,
    changeTargetTabId: (id: number | null): void => setTargetTabId(id),
    editHomeTab: (tab: HomeTabEditRequest): void => mutate(tab),
    isEditHomeTabLoading: isLoading,
  };
};
